import { Button, Icons } from '@healthinal/ui';
import { useNavigate } from '@tanstack/react-router';
import { useAtom } from 'jotai';
import { AnamnesisDtoAnamnesisType, JournalDtoTopic, PatientBasicsDto } from '../../../api/generated/model';
import { tracingContactSelectedPatientFilterAtom } from '../../../state/tracingContactSearchAtoms.ts';

export function NavigateToJournalTopicButton({
  topic,
  patient,
  screeningCaseId,
}: {
  topic: JournalDtoTopic;
  patient: PatientBasicsDto;
  screeningCaseId?: string | null;
}) {
  const [_, setSelectedTracingContactPatientFilter] = useAtom(tracingContactSelectedPatientFilterAtom);
  const navigate = useNavigate();
  switch (topic) {
    case JournalDtoTopic.PERSONAL_DETAILS:
      return (
        <Button
          endDecorator={<Icons.ArrowForward />}
          onClick={() => navigate({ to: '/patients/$patientId', params: { patientId: patient.id } })}>
          Zu Personalien
        </Button>
      );
    case JournalDtoTopic.ANAMNESIS:
      return (
        <Button
          endDecorator={<Icons.ArrowForward />}
          onClick={() =>
            navigate({
              to: '/patients/$patientId/anamnesis',
              params: { patientId: patient.id },
              search: { selectedAnamnesisType: AnamnesisDtoAnamnesisType.MEDICAL },
            })
          }>
          Zur Anamnese
        </Button>
      );
    case JournalDtoTopic.DIAGNOSTICS:
      return (
        <Button
          endDecorator={<Icons.ArrowForward />}
          onClick={() => navigate({ to: '/patients/$patientId/diagnostics', params: { patientId: patient.id } })}>
          Zur Diagnostik
        </Button>
      );
    case JournalDtoTopic.THERAPY:
      return (
        <Button
          endDecorator={<Icons.ArrowForward />}
          onClick={() => navigate({ to: '/patients/$patientId/therapy', params: { patientId: patient.id } })}>
          Zur Therapie
        </Button>
      );
    case JournalDtoTopic.NETWORK:
      return (
        <Button
          endDecorator={<Icons.ArrowForward />}
          onClick={() => navigate({ to: '/patients/$patientId/network', params: { patientId: patient.id } })}>
          Zum Netzwerk
        </Button>
      );
    case JournalDtoTopic.CONTACT_TRACING:
      return (
        <Button
          endDecorator={<Icons.ArrowForward />}
          onClick={() => {
            void navigate({ to: '/contact-tracing' });
            setSelectedTracingContactPatientFilter(patient);
          }}>
          Zum Contact Tracing
        </Button>
      );
    case JournalDtoTopic.TRACING_CONTACT:
      return (
        <Button
          endDecorator={<Icons.ArrowForward />}
          onClick={() => navigate({ to: '/contact-tracing/$patientId', params: { patientId: patient.id } })}>
          Zur Kontaktperson
        </Button>
      );
    case JournalDtoTopic.SCREENING_PERSON:
      return (
        <Button
          endDecorator={<Icons.ArrowForward />}
          disabled={!screeningCaseId}
          onClick={() => {
            if (!screeningCaseId) {
              return;
            }
            void navigate({
              to: '/screening/$screeningId/individuals/$individualId',
              params: { screeningId: screeningCaseId, individualId: patient.id },
            });
          }}>
          Zur Screeningperson
        </Button>
      );
  }
}
